import { Injectable } from '@angular/core';

import { FsAdvancedFeatureMarker, IAdvancedFeatureOptions } from '../advanced-feature-marker';
import { FsAdvancedMarker } from '../advanced-marker';
import { IGoogleMarker } from '../interfaces/google-marker.interface';

/**
 * Factory service for creating Google marker instances.
 * This allows Google Maps dependencies to be injected once into the factory
 * and then used to create markers, avoiding direct injection into marker classes.
 */
@Injectable()
export class GoogleMarkerFactoryService {
  /**
   * Create a new FsAdvancedMarker instance
   */
  public createMarker(options: google.maps.marker.AdvancedMarkerElementOptions): IGoogleMarker {
    return new FsAdvancedMarker(options);
  }

  /**
   * Create a new FsAdvancedFeatureMarker instance
   */
  public createFeatureMarker(options: IAdvancedFeatureOptions): IGoogleMarker {
    return new FsAdvancedFeatureMarker(options) as unknown as IGoogleMarker;
  }
}
